'use strict';

import moment from 'moment';

// presets
//# Note - slot_ids must be a tuple which defines the start and end time of the
//# slot.

// 30/10/25 added full respite day (slots 1-12)

const default_sessions = [
  { type: 1, slot_ids: [1, 7] },
  { type: 1, slot_ids: [1, 12] },
  { type: 1, slot_ids: [7, 13] },
  { type: 2, slot_ids: [1, 13] },
];
const saturday_sesssions = [
  { type: 1, slot_ids: [0, 4] },
  { type: 2, slot_ids: [0, 9] },
  { type: 1, slot_ids: [5, 9] },
  { type: 2, slot_ids: [5, 14] },
  { type: 1, slot_ids: [10, 14] },
];

const data = {
  /**
   * TVAP offers 30 min 'slots' which (in normal times) can be booked as a
   * block.
   * During COVID these are offered as contiguous 'sessions' and users can only
   * request a place in one of these sessions e.g. 11:30 to 13:00
   */

  slots: [
    { id: 0, time: '09:30' },
    { id: 1, time: '10:00' },
    { id: 2, time: '10:30' },
    { id: 3, time: '11:00' },
    { id: 4, time: '11:30' },
    { id: 5, time: '12:00' },
    { id: 6, time: '12:30' },
    { id: 7, time: '13:00' },
    { id: 8, time: '13:30' },
    { id: 9, time: '14:00' },
    { id: 10, time: '14:30' },
    { id: 11, time: '15:00' },
    { id: 12, time: '15:30' },
    { id: 13, time: '16:00' },
    { id: 14, time: '16:30' },
  ],

  /**
   * All one-off 'special' opening hours are declared here. The lookup function
   * will check here first, if found then nothing else to do.
   * If not found, then the session times are dependent on the day of the week.
   */

  holidays: [
    // { date: '2021-07-20' },
    // { date: '2021-07-21' },
    // { date: '2021-07-22' },
    // { date: '2021-07-27' },
    // { date: '2021-07-28' },
    // { date: '2021-07-29' },
    // { date: '2021-08-03' },
    // { date: '2021-08-04' },
    // { date: '2021-08-05' },
    // { date: '2021-08-10' },
    // { date: '2021-08-11' },
    // { date: '2021-08-12' },
    // { date: '2021-08-17' },
    // { date: '2021-08-18' },
    // { date: '2021-08-19' },
    // { date: '2021-08-24' },
    // { date: '2021-08-25' },
    // { date: '2021-08-26' },
    // { date: '2021-08-31' },
    // { date: '2021-09-01' },
    // { date: '2021-09-02' },
    // { date: '2021-10-27' },
    // { date: '2021-10-28' },
  ],

  /**
   * TVAP is only open on certain days of the week and, on those days, offers
   * 2-3 sessions depending on the day. These sessions are defined and maintained
   * here.
   */

  /**
   * 19 Jan 2022 - all days default to the same times i.e. as per Friday
   */

  sessions: [
    { id: 'mo', slots: [{ type: 0, slot_ids: [] }] },
    {
      id: 'tu',
      slots: default_sessions,
    },
    {
      id: 'we',
      slots: default_sessions,
    },
    {
      id: 'th',
      slots: default_sessions,
    },
    {
      id: 'fr',
      slots: default_sessions,
    },
    {
      id: 'sa',
      // slots: default_sessions,
      slots: [...default_sessions, { type: 1, slot_ids: [9, 13] }],
    },
    { id: 'su', slots: [{ type: 0, slot_ids: [] }] },
  ],
};

/**
 * API using the data declared above.
 *
 * slotsForDate(d) => returns a nested array of the session start and end times
 *                    available on the supplied date.
 */

function slotsForDate(date) {
  const times = outer => {
    // a day with no sessions will still contain a single object i.e.
    // { type:0, slot_ids:[] }
    if (outer.length === 1 && outer[0].slot_ids.length === 0) return [];

    return outer.map(session => {
      return session.slot_ids.reduce((acc, id) => {
        const obj = data.slots.find(slot => slot.id === id);
        acc.push(obj);
        return acc;
      }, []);
    });
  };

  // Holidays usually follow Saturday session times and description.
  // These are the default but they can be overridden in the special object.
  const special = data.holidays.find(s => s.date === date);
  if (special) {
    const conditions = Object.prototype.hasOwnProperty.call(
      special,
      'conditions'
    )
      ? special.conditions
      : 'Open for families of children with special needs (up to age 17). Limited spaces for children without special needs and their families (up to age 13)';
    const slots = Object.prototype.hasOwnProperty.call(special, 'slots')
      ? special.slots
      : saturday_sesssions;
    return { conditions, slots: times(slots) };
  }

  const dow = moment(date)
    .format('dd')
    .toLowerCase();

  return {
    conditions: null,
    slots: times(data.sessions.find(session => session.id === dow).slots),
  };
}

export { slotsForDate };
